import React from 'react';
import { trackSeeMore, trackCreateClick } from './tracking';

import './ProtestMapBanner.scss';

// eslint-disable-next-line no-unused-vars
const PROTEST_HEADER = 'Fight for racial equality';

export const PROTEST_COLLECTION_URL =
    '/c/black-lives-matter-protests-rallies-and-justice-for-george-floyd-cwxbtpy/';

const BannerContents = () => {
    return (
        <>
            <span
                className="feed-map-banner__header-text eds-text-hm"
                //eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: PROTEST_HEADER,
                }}
            />
            <span className="feed-map-banner__body-text eds-text-weight--regular">
                People are mobilizing around the country. Find the{' '}
                <a
                    className="feed-map-banner__link"
                    href={PROTEST_COLLECTION_URL}
                    onClick={trackSeeMore}
                >
                    nearest protest
                </a>{' '}
                or{' '}
                <a
                    className="feed-map-banner__link"
                    href="/create"
                    onClick={trackCreateClick}
                >
                    start your own
                </a>{' '}
                now.
            </span>
        </>
    );
};

export const MapBannerDesktop = () => {
    return (
        <div className="feed-map-banner--desktop eds-text-bl">
            <BannerContents />
        </div>
    );
};

export const MapBannerMobileTablet = () => {
    return (
        <div className="feed-map-banner--mobile-tablet">
            <BannerContents />
        </div>
    );
};
